import checkAccess from 'config/permissions/checkAccess';
import RolesPocketSafe from 'config/permissions/RolesPocketSafe';

export const PROCESSING_ACTIVITIES_ADMIN_PS_ROLES = [RolesPocketSafe.RopaAdministrator];

type UserDataWithPsRoles = {
  ps_roles?: RolesPocketSafe[];
};

const canAccessProcessingActivitiesAdmin = (userData: UserDataWithPsRoles): boolean =>
  checkAccess(userData.ps_roles ?? [], PROCESSING_ACTIVITIES_ADMIN_PS_ROLES);

export default canAccessProcessingActivitiesAdmin;
